import { Typography } from '@mui/material';
import styled from 'styled-components';
import { localizeDate } from '@elementary/common-ui/utils/datetime';
import { fontSize, space } from '@elementary/common-ui/style/utils';
import { getGroupingStrategyDisplay } from '../../utils';
import { IncidentDetail } from '../../types';

const RowValue = styled(Typography)`
  color: ${({ theme }) => theme.palette.content.primary};
  font-size: ${fontSize('md')};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  row-gap: ${space('lg')};
  column-gap: ${space('lg')};
`;

const RowLabel = styled(Typography)`
  color: ${({ theme }) => theme.palette.content.secondary};
  font-size: ${fontSize('md')};
`;

const Wrapper = styled.div`
  padding: ${space('sm', 0)};
`;

const AttributeValue = ({
  attribute,
}: {
  attribute: IncidentDetail['attributes'][number];
}) => (
  <>
    <RowLabel>{attribute.displayName}</RowLabel>
    <RowValue>
      {attribute.data.dateValue != null
        ? localizeDate(attribute.data.dateValue).format('L LT')
        : attribute.data.stringListValue?.join(', ') ??
          attribute.data.stringValue}
    </RowValue>
  </>
);

type Props = {
  attributes: IncidentDetail['attributes'];
  groupingStrategy: IncidentDetail['groupingStrategy'];
};

const IncidentAttributes = ({ attributes, groupingStrategy }: Props) => (
  <Wrapper>
    <Grid>
      <RowLabel>Grouped by</RowLabel>
      <RowValue>{getGroupingStrategyDisplay(groupingStrategy)}</RowValue>
      {attributes.map((attribute) => (
        <AttributeValue key={attribute.id} attribute={attribute} />
      ))}
    </Grid>
  </Wrapper>
);

export default IncidentAttributes;
